export const CURRENT_BLOGID = 'current_blogid';
export const CURRENT_INDEX = 'current_index';
export const NEXT_BLOG = 'next_blog';
export const LAST_BLOG = 'last_blog';
export const BLOGIDARR = 'blogId_arr';
export const CURRENT_BLOGITEM = 'current_blogitem';
